import { createContext } from '@lyearn/core/utils/context';
import { GenerateCourseLessonFromTopicInput, MaterialConfigInput } from '@/types/schema';

export type CourseUIState = {
  isOfSameWorkspace: boolean;
};

export type AILessonGenerationPropsType = Omit<
  GenerateCourseLessonFromTopicInput,
  'topicName' | 'lessonName' | 'lessonDescription' | 'outcomes' | 'materialConfigs'
> & {
  courseTitle?: string;
  courseGuidance?: string;
  description?: string;
  outcomes: Record<string, string[]>;
  lessonToQuizMap: Record<string, string[]>;
  materialConfigs: MaterialConfigInput[];
}; //lessonName -> outcomes map

type CourseEditorContextType = {
  uiState?: CourseUIState;
  setUiState?: React.Dispatch<React.SetStateAction<CourseUIState>>;
  isAICourseCreator?: boolean;
  aiLessonGenerationProps?: AILessonGenerationPropsType;
  onClickQuiz?: (quizId: string) => void;
  hasGeneratedCourseContentRef?: React.MutableRefObject<boolean>;
  updateHasGeneratedCourseContent?: (value: boolean) => void;
};

export const [CourseEditorProvider, useCourseEditorContext] =
  createContext<CourseEditorContextType>('CourseEditor');
